import { ISurveyConfirm } from "@common/models/SurveyConfirm";
import { IParticipateAction } from "./index";

export const reducer = (state: ISurveyConfirm, action: IParticipateAction): ISurveyConfirm => {

    return { ...state, ...action.payload };
    // switch (action.type) {
    //     case SurveyAction.SurveyConfirm:
    //         return { ...state, ...action.payload }
    //     default:
    //         return { ...state, ...action.payload };
    // }
}